module.exports = __webpack_public_path__ + "media/packs/fonts/IsidoraSans-Medium-a5840881e9dfad58981538dd41c02523.woff";